import { Crown, Star } from 'lucide-react'

interface TierBadgeProps {
  tier: string
  size?: 'sm' | 'md'
}

export function TierBadge({ tier, size = 'sm' }: TierBadgeProps) {
  const sizeClasses = size === 'sm'
    ? 'text-xs px-2 py-0.5 gap-1'
    : 'text-sm px-2.5 py-1 gap-1.5'

  if (tier === 'free') {
    return (
      <span className={`inline-flex items-center rounded-full font-medium capitalize ${sizeClasses} bg-gray-100 text-gray-600`}>
        {tier}
      </span>
    )
  }

  const isBusiness = tier === 'business'
  const Icon = isBusiness ? Crown : Star
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium capitalize ${sizeClasses} ${
        isBusiness
          ? 'bg-amber-100 text-amber-700'
          : 'bg-primary-100 text-primary-700'
      }`}
    >
      <Icon className={iconSize} />
      {tier}
    </span>
  )
}
